import React from 'react';
//components
import TemplateForm from './Components/TemplateForm/TemplateForm';

function App() {
  return (
    <div className="App">
      <TemplateForm />
    </div>
  );
}

export default App;
